import { useRef, useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'
import { firstDayOfWeekAsKey } from 'modules/core/lib/firstDayOfWeek'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'
import FormatsSelector from 'modules/settings/components/FormatsSelector'
import LanguageSelector from 'modules/settings/components/LanguageSelector'
import TimeFormatSelector from 'modules/settings/components/TimeFormatSelector'
import PersonalForm from 'modules/settings/lib/forms/Personal'

import FirstWeekDaySelector from './_FirstWeekDaySelector'

const PersonalSettings = () => {
  const { employee, access } = useCurrentSession()
  const withRegularAccess = hasRegularAccessOrNotEmployee(employee)
  const withLocaleSelector = !hasFeature('ngo_locale')
  const [running, setRunning] = useState(false)

  const personalForm = useRef(
    new PersonalForm({
      first_day_of_week: firstDayOfWeekAsKey(access.firstDayOfWeek),
      locale: access.locale,
      time_format: access.timeFormat
    })
  ).current

  const onSubmitPersonal = async () => {
    if (!personalForm.isDirty) return

    setRunning(true)

    const api = ApiClient()
    const { success } = await asyncAction(() =>
      api.patch(`/accesses/${access.id}`, {
        locale: personalForm.get('locale').value,
        first_day_of_week: personalForm.get('first_day_of_week').value,
        time_format: personalForm.get('time_format').value
      })
    )

    setRunning(false)

    if (success) {
      window.location.reload()
    }
  }

  return (
    <Section.Form
      illustration="user-edit"
      title={i18n.t('personal_settings.personal_settings')}
      description={i18n.t('personal_settings.configure')}
      onSubmit={onSubmitPersonal}
      submitLabel={i18n.t('common.save')}
      isDirty={personalForm.isDirty}
      disabled={running}
    >
      {!!withLocaleSelector && (
        <>
          <LanguageSelector form={personalForm} />
          <FormatsSelector form={personalForm} />
        </>
      )}
      <TimeFormatSelector personalForm={personalForm} />

      {!!withRegularAccess && <FirstWeekDaySelector personalForm={personalForm} />}
    </Section.Form>
  )
}

export default observer(PersonalSettings)
